<template>
  <div class="search">
    <el-input
      v-model="search"
      class="searchInput"
      placeholder="请输入搜索内容"
      size="small"
      suffix-icon="el-icon-search"
      @change="searchFn">
      <el-select
        slot="prepend"
        v-model="type"
        placeholder="请选择"
        :popper-append-to-body="false"
        class="select">
        <el-option
          v-for="(item,index) in selectList"
          :key="index"
          :label="item.label" :value="item.value" />
      </el-select>
    </el-input>
    <SearchDetails
      v-if="ListShow"
      :parame="{search,type}"
      @hide="hide"
    />
  </div>
</template>

<script>
import SearchDetails from './SearchDetails.vue'
export default {
  //
  name: '',
  components: {
    SearchDetails
  },
  props: {},
  data() {
    return {
      ListShow: false,
      search: '',
      type: '',
      selectList: [
        {
          label: '全部',
          value: ''
        },
        {
          label: '标准文库',
          value: 'wenku'
        },
        {
          label: '标准化应用空间',
          value: 'design'
        },
        {
          label: '优秀案例空间',
          value: 'school_room'
        }

        // {
        //   label: '政策通知',
        //   value: 'information'
        // },
        // {
        //   label: '新闻动态',
        //   value: 'guidance_announcement'
        // },
        // {
        //   label: '常见问题',
        //   value: 'help'
        // }
      ]
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    searchFn() {
      this.ListShow = true
    },
    hide() {
      this.ListShow = false
      this.search = ''
      this.type = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.search{
  height: 100%;
  display: flex;
  align-items: center;
  margin-right: 20px;
  /deep/ .el-select .el-input {
    width: 100px;
  }
  /deep/.el-select{
    // background: $xr-color-primary;
    // color: #fff;

  }
    /deep/.el-select__caret{
      //  color: #fff !important;
    }

  .searchInput{
    width: 240px;
    // border: 1px solid #ddd;
    &:hover{
      width: 320px;
      transition: .1s width;
    }
  }

}
</style>
